// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import YouTubePlayer from 'react-player/lib/players/YouTube'
import VimeoPlayer from 'react-player/lib/players/Vimeo'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

const host = window.location.host

class PageEvents extends React.Component {
	componentWillUnmount() {
		window.removeEventListener( 'click', this.handleLinkClick )
		window.removeEventListener( 'click', this.handleShareLinkClick )
		window.removeEventListener( 'click', this.handleNotificationsClick )
		window.removeEventListener( 'click', this.handleAccordionTitleClick )
		window.removeEventListener( 'submit', this.handleFormSubmit )
	}

	componentDidMount() {
		this.update()
	}

	componentDidUpdate( prevProps, prevState ) {
		this.update()
	}

	update = () => {
		// Links:
		const elements = document.querySelectorAll( '.content-body-wrap a, .content-custom-wrap a' )

		Array.from( elements ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleLinkClick )
		})

		// Forms:
		const forms = document.querySelectorAll( '.content-body-wrap form, .content-custom-wrap form' )

		Array.from( forms ).forEach( ( form ) => {
			form.addEventListener( 'submit', this.handleFormSubmit )
		})

		// Notifications:
		const notifications = document.querySelectorAll( '.notification' )

		Array.from( notifications ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleNotificationsClick )
		})

		// Accordions:
		const accordionTitles = document.querySelectorAll( '.accordion-title' )

		Array.from( accordionTitles ).forEach( ( accordionTitle ) => {
			accordionTitle.addEventListener( 'click', this.handleAccordionTitleClick )
		})

		this.updateVideos()
	}

	updateVideos = () => {
		const youtubeVideos = document.querySelectorAll( '.youtube-video' )
		const vimeoVideos = document.querySelectorAll( '.vimeo-video' )

		Array.from( youtubeVideos ).forEach( ( element ) => {
			let url = element.getAttribute( 'data-video-url' )

			ReactDOM.render(
				<YouTubePlayer url={ url } controls={ true } />,
				element
			)
		})

		Array.from( vimeoVideos ).forEach( ( element ) => {
			let url = element.getAttribute( 'data-video-url' )

			ReactDOM.render(
				<VimeoPlayer url={ url } controls={ true } />,
				element
			)
		})

		// Video share links:
		const shareLinks = document.querySelectorAll( '.media-player .-toggle-share-links' )

		Array.from( shareLinks ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleShareLinkClick )
		})
	}

	updatePage = () => {
		const { history } = this.props

		history.push( window.location.pathname )
	}

	handleNotificationsClick = ( e ) => {
		e.currentTarget.classList.toggle( 'is-closed' )
	}

	handleShareLinkClick = ( e ) => {
		let parent = e.currentTarget.parentNode

		parent.classList.toggle( 'with-share-links-open' )
	}

	handleLinkClick = ( e ) => {
		const { history } = this.props
		let href = e.currentTarget.getAttribute( 'href' )
		href = href.replace( /^(\.+)/g, '' )

		if ( href.indexOf( 'mailto:' ) > -1 ) {
			return // Email link, allow normal behaviour.
		} else if ( href.indexOf( host ) > -1 && href.indexOf( '//' ) > -1 ) {
			window.location( href ) // Same network, different site, open normally.
		} else if ( href.indexOf( '//' ) > -1 ) {
			window.open( href, '_blank' ) // External site, in new tab.
		} else if ( '#' == href.charAt( 0 ) ) {
			let hash = href.substring( 1 )
			window.location.hash = hash
		} else {
			history.push( href ) // Same site, use router.
		}

		e.preventDefault()
	}

	handleFormSubmit = ( e ) => {
		const form = e.currentTarget
		const buttons = form.querySelectorAll( 'button' )
		const formData = new FormData( form )
		formData.append( 'action', 'sec_formidable_submit_form' )

		e.preventDefault()

		// Disable the button:
		if ( buttons.length ) {
			buttons[0].setAttribute( 'disabled', 'disabled' )
		}

		form.classList.remove( 'is-successful' )
		form.classList.add( 'is-processing' )

		// Submit:
		doRequest( siteData.ajax_url, {
			method: 'POST',
			body: formData
		})
			.then( message => {
				// Success:

				form.classList.remove( 'has-error' )
				form.setAttribute( 'data-message', '' )

				form.classList.remove( 'is-processing' )
				form.classList.add( 'is-processed' )

				// Add a delay for UX:
				setTimeout( () => {
					form.classList.remove( 'is-processed' )
					form.classList.add( 'is-successful' )

					// Set the success message:
					message && form.setAttribute( 'data-message', message )

					setTimeout( () => {
						form.classList.remove( 'is-successful' )

						// Enable the button:
						if ( buttons.length ) {
							buttons[0].removeAttribute( 'disabled', 'disabled' )
						}

						// Clear the form:
						form.reset()
					}, 1000 )
				}, 1000 )
			})
			.catch( error => {
				// Error:

				form.classList.remove( 'is-processing' )
				form.classList.add( 'is-processed' )

				// Add a delay for UX:
				setTimeout( () => {
					form.classList.remove( 'is-processed' )
					form.classList.add( 'is-unsuccessful' )

					// Set the error text:
					form.classList.add( 'has-error' )
					error && form.setAttribute( 'data-message', error )

					setTimeout( () => {
						form.classList.remove( 'is-unsuccessful' )

						// Enable the button:
						if ( buttons.length ) {
							buttons[0].removeAttribute( 'disabled', 'disabled' )
						}
					}, 3000 )
				}, 1000 )
			})
	}

	handleAccordionTitleClick = ( e ) => {
		e.preventDefault()

		let section = e.currentTarget.parentNode

		if ( ! section.classList.contains( 'is-active' ) && ! section.classList.contains( 'is-target' ) ) {
			section.classList.remove( 'is-not-active' )
			section.classList.add( 'is-active' )
		} else {
			section.classList.add( 'is-closing' )
			section.classList.remove( 'is-active' )
			section.classList.remove( 'is-target' )

			setTimeout( () => {
				section.classList.remove( 'is-closing' )
				section.classList.add( 'is-not-active' )
			}, 750 )
		}
	}

	render() {
		return null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default withRouter(
	connect( mapStateToProps )( PageEvents )
)
